import { defineMessages } from 'react-intl';

export const MESSAGES = defineMessages({
    no: {
        id: 'blsq.buttons.label.no',
        defaultMessage: 'No',
    },
    yes: {
        id: 'blsq.buttons.label.yes',
        defaultMessage: 'Yes',
    },
});
